import { render, staticRenderFns } from "./HsaBankForms.vue?vue&type=template&id=72c370bb&scoped=true"
import script from "./HsaBankForms.vue?vue&type=script&lang=ts"
export * from "./HsaBankForms.vue?vue&type=script&lang=ts"
import style0 from "./HsaBankForms.vue?vue&type=style&index=0&id=72c370bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c370bb",
  null
  
)

export default component.exports